import { __generator } from "tslib";
import { request } from '../../xhr';
import { call, put, all, takeEvery, delay } from 'redux-saga/effects';
import { normalize } from '../../redux/normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { actions as ModalActions } from '../../Modals';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { createPollRequest as createPollRequestAction, updatePollRequest as updatePollRequestAction, createPollSuccess as createPollSuccessAction, updatePollSuccess as updatePollSuccessAction, requestFailure, } from './actions';
import { actions as notificationActions, NotificationType, } from '../../Notifications';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import { editDeviationSuccess } from '../../redux/deviations/actionCreators';
import { logBiEvent } from '../../biLogger/redux/saga';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../types/resource';
function postRequest(url, data) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: url,
                    data: data,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
export function createPollRequestSaga(action) {
    var payload, params, response, normalizedDeviation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                params = {
                    question: payload.question,
                    answers: payload.answers,
                };
                return [4 /*yield*/, call(postRequest, '/poll/create', params)];
            case 1:
                response = _a.sent();
                if (!(response && response.deviation)) return [3 /*break*/, 4];
                normalizedDeviation = normalize(response.deviation, deviationSchema);
                return [4 /*yield*/, all([
                        call(logBiEvent, PureBiData({
                            evid: 11,
                            group_exclusive: false,
                            typeid: ResourceType.POLL_BLOG,
                            itemid: response.deviation.deviationId,
                        })),
                        put(createPollSuccessAction(normalizedDeviation)),
                        put(ModalActions.popModal()),
                    ])];
            case 2:
                _a.sent();
                return [4 /*yield*/, delay(400)];
            case 3:
                _a.sent();
                if (payload.refreshAfterSubmit) {
                    window.location.reload();
                }
                else {
                    window.location.assign(getDeviationUrl(response.deviation));
                }
                return [3 /*break*/, 6];
            case 4:
                if (response && response.errorCode === 302) {
                    window.location.replace(response.errorDetails.redirectUrl);
                }
                return [4 /*yield*/, all([
                        put(notificationActions.addNotification(NotificationType.Generic, {
                            messageLocaleKey: 'common.somethingWentWrong',
                            cardProps: { iconComponent: ErrorIcon },
                        })),
                        put(requestFailure()),
                    ])];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export function updatePollRequestSaga(action) {
    var payload, params, response, normalizedDeviation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                params = {
                    pollid: payload.pollId,
                    question: payload.question,
                    answers: payload.answers,
                };
                return [4 /*yield*/, call(postRequest, '/poll/update', params)];
            case 1:
                response = _a.sent();
                if (!(response && response.deviation)) return [3 /*break*/, 3];
                normalizedDeviation = normalize(response.deviation, deviationSchema);
                return [4 /*yield*/, all([
                        put(updatePollSuccessAction(normalizedDeviation)),
                        put(editDeviationSuccess({ deviation: response.deviation })),
                        put(ModalActions.popModal()),
                    ])];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, all([
                    put(notificationActions.addNotification(NotificationType.Generic, {
                        messageLocaleKey: 'common.somethingWentWrong',
                        cardProps: { iconComponent: ErrorIcon },
                    })),
                    put(requestFailure()),
                ])];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function pollsSagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(updatePollRequestAction, updatePollRequestSaga),
                    takeEvery(createPollRequestAction, createPollRequestSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=sagas.js.map